import Logo from "../../assets/logo.png";
import icon1 from "../../assets/invoice.png";
import icon2 from "../../assets/support-ticket.png";
import icon3 from "../../assets/trade.svg";
import { Link, Navigate, NavLink, useLocation, useNavigate } from "react-router-dom";
import shipment from "../../assets/shipments.png";
import dashboard from "../../assets/dashboard.png";
import shipmentWhite from "../../assets/shipmentWhite.png";
import orderHistory from "../../assets/orderHistory.png";
import orderHistoryWhite from "../../assets/orderHistoryWhite.png";
import dashboardWhite from "../../assets/dashboardWhite.png";
import clientWhite from "../../assets/clientWhite.png";
import client from "../../assets/client.png";
import setting from "../../assets/setting.png";
import settingWhite from "../../assets/settingWhite.png";
import helpwhite from "../../assets/helpwhite.png";
import quotewhite from "../../assets/quotewhite.png";
import shipwhite from "../../assets/shipwhite.png";
import trackwhite from "../../assets/trackwhite.png";
import adminI from "../../assets/admin.png";
import adminIwhite from "../../assets/adminWhite.png";
import todo from '../../assets/todo.png';
import todoWhite from '../../assets/todowhite.png';
import quote from '../../assets/quote.png';
import quoteWhite from '../../assets/quotewhite.png';
import newInquiries from '../../assets/new-inquiries.png';
import newInquiriesWhite from '../../assets/new-inquiries-white.png';
import invoiceWhite from "../../assets/invoiceWhite.png";
import supportTicketWhite from "../../assets/support-ticket-white.png";
import NewQuotes from "../../assets/NewQuotes.png";
import WhiteNewQuotes from "../../assets/WhiteNewQuotes.png";
import MyQuotes from "../../assets/MyQuotes.png";
import WhiteMyQuotes from "../../assets/WhiteMyQuotes.png";
import NewRequest from "../../assets/NewRequest.png";
import WhiteNewRequest from "../../assets/WhiteNewRequest.png";
import MyShipments from "../../assets/MyShipments.png";
import WhiteMyShipments from "../../assets/WhiteMyShipments.png";
import ShipmentHistory from "../../assets/ShipmentHistory.png";
import WhiteShipmentHistory from "../../assets/WhiteShipmentHistory.png";
import Tracking from "../../assets/Tracking.png";
import WhiteTracking from "../../assets/WhiteTracking.png";
import IOR from "../../assets/IOR.png";
import { useMyContext } from "../../context/MyContext";
import { LuListTodo } from "react-icons/lu";
import { MdOutlineOndemandVideo } from "react-icons/md";
import WelcomeTour from '../dashboard/WelcomeTour';

function SideBar({ obj }) {
  const { user, welcomeTourActive } = useMyContext();

  const roleis = user?.role;
  // console.log("roleis", roleis);
  // console.log(user, "hn");
  const { pathname } = useLocation();
  const navigate = useNavigate();

  // Check if the current route is an estimate route
  const isEstimateRoute = pathname.startsWith('/estimate/');

  const items =
    roleis === "super admin" ||
      roleis === "managing admin" ||
      roleis === "lead admin" ||
      roleis === " admin" ||
      roleis === "editor"
      ? [
        {
          content: "Dashboard",
          src: dashboard,
          path: "/dashboard",
          active: false,
          activeSrc: dashboardWhite,
        },
        {
          content: "Shipments",
          src: shipment,
          path: "/shipments",
          active: false,
          activeSrc: shipmentWhite,
        },
        {
          content: "Order History",
          src: orderHistory,
          path: "/orderhistory",
          active: false,
          activeSrc: orderHistoryWhite,
        },
        // {
        //   content: "Clients",
        //   src: client,
        //   path: "/clients",
        //   active: false,
        //   activeSrc: clientWhite,
        // },
        {
          content: "Admins",
          src: adminI,
          path: "/admins",
          active: false,
          activeSrc: adminIwhite,
        },
        {
          content: "Clients",
          src: client,
          path: "/clients",
          active: false,
          activeSrc: clientWhite,
        },
        {
          content: "Quote",
          src: quote,
          path: "/quoteadmin",
          active: false,
          activeSrc: quoteWhite,
        },
        // --- ADMIN TRADEOS LINK ---
        {
          content: "TradeOS™",
          src: IOR,
          path: "/admin-oneunion-trade-os",
          active: false,
          activeSrc: trackwhite,
        },
        // --- ADMIN HS COMPASS LINK ADDED HERE ---
        {
          content: "HS Compass™",
          src: IOR,
          path: "/hs-compass", // Uses the existing client path/component
          active: false,
          activeSrc: trackwhite,
        },
        // ------------------------------------

        {
          content: "New Inquiries",
          src: NewRequest,
          path: "/newRequest",
          active: false,
          activeSrc: WhiteNewRequest,
        },
        // {
        //   content: "Tracking",
        //   src: icon3,
        //   path: "/trackshipment",
        //   active: false,
        //   activeSrc: trackwhite,
        // },
        {
          content: "Invoices",
          src: icon1,
          path: "/invoices",
          active: false,
          activeSrc: invoiceWhite,
        },
        {
          content: "To Do",
          src: todo,
          path: "/todo",
          active: false,
          activeSrc: todoWhite,
        },
        {
          content: "Settings",
          src: setting,
          path: "/settings",
          active: false,
          activeSrc: settingWhite,
        },
        {
          content: "Support Tickets",
          src: icon2,
          path: "/tickets",
          active: false,
          activeSrc: supportTicketWhite,
        },
        // { content: "Quote", src: setting, path: "/quotes", active: false, activeSrc: settingWhite },
      ]
      : roleis === "user"
        ? [
          {
            content: "Dashboard",
            src: dashboard,
            path: "/dashboard",
            active: false,
            activeSrc: dashboardWhite,
          },
          {
            content: "New Quotes",
            src: NewQuotes,
            path: "/newquotes",
            active: false,
            activeSrc: WhiteNewQuotes,
          },
          {
            content: "My Quotes",
            src: MyQuotes,
            path: "/myqoutes",
            active: false,
            activeSrc: WhiteMyQuotes,
          },
          {
            content: "New Request",
            src: NewRequest,
            path: "/bookshipment",
            active: false,
            activeSrc: WhiteNewRequest,
          },
          // {
          //   content: "Stakeholder",
          //   src: NewRequest,
          //   path: "/stakeholder",
          //   active: false,
          //   activeSrc: WhiteNewRequest,
          // },
          {
            content: "My Shipments",
            src: MyShipments,
            path: "/myShipment",
            active: false,
            activeSrc: WhiteMyShipments,
          },
          {
            content: "Tracking",
            src: Tracking,
            path: "/trackshipment",
            active: false,
            activeSrc: WhiteTracking,
          },
          // {
          //   content: "Tracking",
          //   src: icon1,
          //   path: "/tracking",
          //   active: false,
          //   activeSrc: quotewhite,
          // },
          // {
          //   content: "IOR Calculator",
          //   src: IOR,
          //   path: "/ior-calculator",
          //   active: false,
          //   activeSrc: trackwhite,
          // },
          {
            content: "TradeOS™",
            src: IOR,
            path: "/oneunion-trade-os",
            active: false,
            activeSrc: trackwhite,
          },
          {
            content: "HS Compass™",
            src: IOR,
            path: "/hs-compass",
            active: false,
            activeSrc: trackwhite,
          },
          {
            content: "Invoices",
            src: icon1,
            path: "/invoices",
            active: false,
            activeSrc: invoiceWhite,
          },
          {
            content: "Shipment History",
            src: ShipmentHistory,
            path: "/shipmenthistory",
            active: false,
            activeSrc: WhiteShipmentHistory,
          },
          {
            content: "Support & Help",
            src: icon2,
            path: "/support&help",
            active: false,
            activeSrc: supportTicketWhite,
          },
          {
            content: "Tutorials",
            srcType: "icon",
            // Default (not active): neutral gray to match other items
            src: <MdOutlineOndemandVideo size={25} className="text-gray-500" />,
            // Active: white (icon sits on gradient/blue background like others)
            activeSrc: <MdOutlineOndemandVideo size={25} className="text-white" />,
            path: "/tutorials",
            active: false,
          },
        ]
        : roleis === "stakeholder"
          ? [
            {
              content: "Dashboard",
              src: dashboard,
              path: "/dashboard",
              active: false,
              activeSrc: dashboardWhite,
            },
            {
              content: "My Shipments",
              src: MyShipments,
              path: "/myShipment",
              active: false,
              activeSrc: WhiteMyShipments,
            },
            {
              content: "Tracking",
              src: Tracking,
              path: "/trackshipment",
              active: false,
              activeSrc: WhiteTracking,
            },
            // {
            //   content: "Shipment History",
            //   src: ShipmentHistory,
            //   path: "/shipmenthistory",
            //   active: false,
            //   activeSrc: WhiteShipmentHistory,
            // },
          ]
          : [];
  // const findValue = items?.filter((item) => item?.content === obj?.content);

  let classs = " bg-cus-blue text-white ";
  let bool = true;

  const foo = (e) => {
    e.target.parentNode.className += classs;
  };

  return (
    <>
      <div className="sm:translate-x-0 -translate-x-full  w-full bg-white  h-full flex flex-col">
        {/* <Link to="/"> */}
        <div className="grid place-items-center">
          <img onClick={() => navigate("/dashboard")} style={{ cursor: "pointer" }} className="w-32 " src={Logo} alt="logo" />
        </div>
        {/* </Link> */}
        <div className="flex-1 overflow-y-auto [&::-webkit-scrollbar]:hidden hover:[&::-webkit-scrollbar]:block">
          <ul className="pt-4 flex gap-3 flex-col justify-center px-1">
            {items?.map((item, index) => (
              <li key={index}>
                <NavLink
                  data-tour-id={item.path.slice(1)}
                  className={`${(pathname === item?.path || (item.path === "/ior-calculator" && isEstimateRoute))
                    ? "btnBg text-white" : ""} rounded-md py-3 px-3 text-sm font-normal flex gap-2 items-center overflow-hidden`}
                  to={item?.path}
                // className={`flex hover:bg-cus-blue hover:text-white transition-all items-center justify-start p-2 text-xs gap-3 `}
                >
                  {item.srcType === "icon" ? (
                    pathname === item?.path ? (
                      item?.activeSrc
                    ) : (
                      item?.src
                    )
                  ) : (
                    <img
                      className="w-[25px] text-black h-[25px] flex-shrink-0"
                      src={(pathname === item?.path || (item.path === "/ior-calculator" && isEstimateRoute))
                        ? item.activeSrc
                        : item.src}
                      alt={item.content}
                    />
                  )}
                  <p>{item.content}</p>
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      </div>
      {welcomeTourActive && <WelcomeTour onComplete={() => console.log('Tour completed')} />}
    </>
  );
}

export default SideBar;